import React from 'react';
import './Services.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop, faBullseye, faCloud, faHeadset, faShoppingCart } from '@fortawesome/free-solid-svg-icons';

export default function Services() {

    // Icons
    const faDesktopIcon = <FontAwesomeIcon icon={faDesktop} />
    const faBullseyeIcon = <FontAwesomeIcon icon={faBullseye} />
    const faCloudIcon = <FontAwesomeIcon icon={faCloud} />
    const faHeadsetIcon = <FontAwesomeIcon icon={faHeadset} />
    const faShoppingCartIcon = <FontAwesomeIcon icon={faShoppingCart} />

    return (
        <>
            <div id="services">
                <div className="container">
                    <div className="title_headling">
                        <h3>Our Services for Our Valued Customers</h3>
                        <p>We provide a range of solutions designed to meet your unique needs, delivered with quality and care.</p>
                    </div>

                    <div className="service_wrapper">
                        {/* Secretarial Services */}
                        <div className="service_box">
                            <div className="service_icon blue_icon">{faDesktopIcon}</div>
                            <h4 className="number">01</h4>
                            <div className="service_content">
                                <h5>SECRETARIAL SERVICES</h5>
                                <p>Professional administrative support, document management, and corporate assistance to ensure compliance, organization, and efficiency in business operations and daily tasks.</p>
                            </div>
                        </div>

                        {/* Consulting */}
                        <div className="service_box">
                            <div className="service_icon">{faBullseyeIcon}</div>
                            <h4 className="number">02</h4>
                            <div className="service_content">
                                <h5>CONSULTING</h5>
                                <p>Business and IT consulting services that help optimize operations, improve resources, and achieve goals, offering tailored recommendations and actionable insights for success.</p>
                            </div>
                        </div>

                        {/* Training */}
                        <div className="service_box">
                            <div className="service_icon green_icon">{faCloudIcon}</div>
                            <h4 className="number">03</h4>
                            <div className="service_content">
                                <h5>TRAINING</h5>
                                <p>Comprehensive programs in IT, business, and marketing designed to enhance skills, empower teams, and promote growth, while preparing individuals for future career challenges.</p>
                            </div>
                        </div>
                    </div>


                    {/* Voucher Section */}
                    <div className="voucher_section">
                        <h5 className="voucher_title">VOUCHER SALES</h5> {/* Separate title */}
                        <p className="voucher_description">
                            Explore a wide selection of digital and physical vouchers that provide convenient access to entertainment, mobile services, and more. Each voucher is designed to be easy to use and offers great flexibility.
                        </p>
                        <div className="voucher_cards">
                            {/* Netflix Voucher Card */}
                            <div className="services_box">
                                <div className="service_content">
                                    <h5>Netflix Voucher</h5>
                                    <p>Enjoy unlimited streaming of movies, TV shows, and documentaries with Netflix vouchers available in various denominations.</p>
                                </div>
                            </div>
                            
                            {/* DSTV Voucher Card */}
                            <div className="services_box">
                                <div className="service_content">
                                    <h5>DSTV Voucher</h5>
                                    <p>Gain access to premium television content with DSTV vouchers, offering various subscription plans to suit your entertainment needs.</p>
                                </div>
                            </div>

                            {/* Mobile International SIM Card Card */}
                            <div className="services_box">
                                <div className="service_content">
                                    <h5>Mobile International SIM Cards</h5>
                                    <p>Purchase international SIM cards for easy communication while traveling, ensuring global connectivity and convenience.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
